export const mapConstructionNumbers = (data) =>
    data.map((value) => ({
      id: value.id,
      active: value.active,
      number: value.constructionNumber,
      state:
          value.statusInOption === null || value.statusInOption === false
              ? value.status
              : 'In optie',
      kind: value.housingKind,
      type: value.housingType !== null ? value.housingType.description : null,
      housingVariant: value.housingVariant ? value.housingVariant : value.typeCluster,
      typeId: value.housingType !== null ? value.housingType.id : null,
      metrics: {
        parcel: value.parcelArea,
        living: value.livingArea
      },
      prices: {
        definitive: value.definitivePrice,
        indicative: value.indicativePrice,
        indicativeMax: value.indicativePriceMax,
        rentPrice: value.rentPrice
      },
      address: value.address,
      image: value.housingType !== null ? value.housingType.mainThumbnail : null
    }));

export const mapHousingTypes = (data, constructionNumbers, isRental) =>
    data.map((value) => {
      const constructionNrs = constructionNumbers.filter(
          (number) => number.typeId === value.id
      );

      if (constructionNrs.length === 0) return null;

      let typePrice = null;
      if (isRental) {
        if (constructionNrs.find((item) => item.prices.rentPrice && item.state !== 'Verhuurd')) {
          typePrice = constructionNrs.filter((item) => item.prices.rentPrice).sort(
              (a, b) => a.prices.rentPrice - b.prices.rentPrice
          )[0].prices.rentPrice;
        } else {
          typePrice = 'Binnenkort bekend';
        }
      } else if (constructionNrs.find((item) => item.prices.definitive && item.state !== 'Verkocht')) {
        typePrice = constructionNrs.filter((item) => item.prices.definitive).sort(
            (a, b) => a.prices.definitive - b.prices.definitive
        )[0].prices.definitive;
      } else if (constructionNrs.find((item) => item.prices.indicative && item.state !== 'Verkocht')) {
        typePrice = constructionNrs.filter((item) => item.prices.indicative).sort(
            (a, b) => a.prices.indicative - b.prices.indicative
        )[0].prices.indicative;
      } else if (constructionNrs.filter((item) => item.state !== 'Verkocht').length === 0) {
        typePrice = '-';
      }

      let houseClusterName = '';

      if (isRental) {
        houseClusterName = value.description;
      } else {
        // eslint-disable-next-line prefer-destructuring
        houseClusterName = value.description.split(' - ')[1];
        houseClusterName = (houseClusterName.includes('type', 0) || houseClusterName.includes('Type', 0) ? '' : 'type ') + houseClusterName;
      }

      return {
        id: value.id,
        title: value.description,
        houseKind: constructionNrs[0].kind,
        houseCluster: houseClusterName,
        image: value.mainThumbnail,
        price: typePrice
      };
    }).filter((item) => item !== null);
